module.exports = __webpack_public_path__ + "assets/img/37_1622_big.a04ced19.jpg";